/**
 * Dark Mode Palette — Modern Enterprise Design System
 *
 * Rich, deep dark mode with refined contrast levels.
 * Avoids pure black — uses layered dark surfaces for depth.
 */

import {
  COLOR_PRIMARY_LIGHT,
  COLOR_PRIMARY,
  COLOR_SECONDARY_LIGHT,
  COLOR_SECONDARY,
  COLOR_SUCCESS_LIGHT,
  COLOR_SUCCESS,
  COLOR_WARNING_LIGHT,
  COLOR_WARNING,
  COLOR_DANGER_LIGHT,
  COLOR_DANGER,
  COLOR_INFO_LIGHT,
  COLOR_INFO,
  COLOR_NEUTRAL_LIGHT,
  COLOR_NEUTRAL,
} from './tokens.js';

const darkPalette = {
  mode: 'dark',
  primary: {
    main: '#60a5fa',
    light: '#93c5fd',
    dark: COLOR_PRIMARY,
    contrastText: '#0f172a',
  },
  secondary: {
    main: '#a78bfa',
    light: '#c4b5fd',
    dark: COLOR_SECONDARY,
    contrastText: '#0f172a',
  },
  success: {
    main: '#34d399',
    light: '#6ee7b7',
    dark: COLOR_SUCCESS,
    contrastText: '#0f172a',
  },
  warning: {
    main: '#fbbf24',
    light: '#fcd34d',
    dark: COLOR_WARNING,
    contrastText: '#0f172a',
  },
  error: {
    main: '#f87171',
    light: '#fca5a5',
    dark: COLOR_DANGER,
    contrastText: '#0f172a',
  },
  info: {
    main: '#38bdf8',
    light: '#7dd3fc',
    dark: COLOR_INFO,
    contrastText: '#0f172a',
  },
  grey: {
    50: '#1e293b',
    100: '#1e293b',
    200: '#334155',
    300: '#475569',
    400: '#64748b',
    500: '#94a3b8',
    600: '#cbd5e1',
    700: '#e2e8f0',
    800: '#f1f5f9',
    900: '#f8fafc',
    main: COLOR_NEUTRAL_LIGHT,
    light: '#cbd5e1',
    dark: COLOR_NEUTRAL,
    contrastText: '#0f172a',
  },
  background: {
    default: '#0c0f1a',
    paper: '#141825',
  },
  text: {
    primary: '#f1f5f9',
    secondary: '#94a3b8',
    disabled: '#475569',
  },
  divider: 'rgba(148, 163, 184, 0.12)',
  action: {
    active: 'rgba(241, 245, 249, 0.56)',
    hover: 'rgba(241, 245, 249, 0.05)',
    selected: 'rgba(59, 130, 246, 0.15)',
    disabled: 'rgba(241, 245, 249, 0.26)',
    disabledBackground: 'rgba(241, 245, 249, 0.08)',
    focus: 'rgba(59, 130, 246, 0.2)',
  },
};

export default darkPalette;
